import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: boolean = false;

const slice = createSlice({
  name: 'enableThemeTools',
  initialState,
  reducers: {
    setEnableThemeTools(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableThemeTools } = slice.actions;

export default slice.reducer;
